import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

const Footer = () => {
    return (
        <AppBar
            position="fixed"
            component="footer"
            sx={{ backgroundColor: '#1976d2', top: 'auto', bottom: 0 }}
        >
            <Toolbar sx={{ justifyContent: 'center' }}>
                <Typography
                    variant="body2"
                    sx={{
                        fontFamily: 'Montserrat, sans-serif',
                        textAlign: 'center',
                    }}
                >
                    Brought to you by:{' '}
                    <a
                        href="https://cox.enterprise.slack.com/archives/C08KTFXSB5M"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#fff', fontWeight: 700 }}
                    >
                        TBD
                    </a>
                </Typography>
            </Toolbar>
        </AppBar>
    );
};

export default Footer;
